import { render } from "./Countdown.vue?vue&type=template&id=c69b40b4&ts=true"
import script from "./Countdown.vue?vue&type=script&lang=ts"
export * from "./Countdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__